<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="@/assets/back.png" alt="返回" />
          <span>返回</span>
        </div>
      </div>

      <!-- 基础信息 -->
      <Title class="mt20">基础信息</Title>
      <div class="basic-info">
        <div class="info-item">
          <div class="product-image" v-if="info.coverImage">
            <img :src="info.coverImage" alt="产品图片" class="product-img" />
          </div>
          <div class="title-with-product">
            <p class="title-text">{{ formatTitle(info.title || info.titleJson) }}</p>
            <p class="p1">原文章：{{ formatTitle(info.originalTitle || info.title) || '--' }}</p>
            <p class="p1">发布者：{{ info.createdBy || '平台发布' }}</p>
            <p class="p1">创建时间：{{ info.createdTime || '--' }}</p>
            <p class="p1">分享者：{{ formatSharer(info.shareUserName, info.shareUserIdentity, info.shareUserPho) }}</p>
            <p class="p1">分享时间：{{ info.createdTime || '--' }}</p>
          </div>
        </div>
        <el-descriptions :column="3">
          <el-descriptions-item label="分类">{{ info.shareShowVO && info.shareShowVO.classificationName || info.classificationName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="会议类型">{{ info.meetingType || '--' }}</el-descriptions-item>
          <el-descriptions-item label="会议">{{ info.meetingName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="实际浏览量">{{ info.abrowseNum !== undefined ? info.abrowseNum : (info.browseNum || 0) }}</el-descriptions-item>
          <el-descriptions-item label="实际点赞量">{{ info.alikeNum !== undefined ? info.alikeNum : (info.likeNum || 0) }}</el-descriptions-item>
          <el-descriptions-item label="实际转发量">{{ info.aforwardNum !== undefined ? info.aforwardNum : (info.forwardNum || 0) }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 文章详情 -->
      <Title class="mt20">文章详情</Title>
      <el-descriptions :column="2">
        <el-descriptions-item label="文章logo图">
          <el-image
            v-if="info.logoImg"
            style="width: 50px; height: 50px; border-radius: 50%"
            :src="info.logoImg"
            :preview-src-list="[info.logoImg]"
          ></el-image>
          <span v-else>--</span>
        </el-descriptions-item>
        <el-descriptions-item label="技术老师描述">
          <el-image
            v-if="info.coverImage"
            style="width: 50px; height: 50px; border-radius: 50%"
            :src="info.coverImage"
            :preview-src-list="[info.coverImage]"
          ></el-image>
          <span v-else>--</span>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="3">
        <el-descriptions-item label="时间">{{ info.contactTime || '--' }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ info.contactName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ info.contactPho || '--' }}</el-descriptions-item>
        <el-descriptions-item label="地址" :span="3">{{ info.contactAddress || '--' }}</el-descriptions-item>
      </el-descriptions>

      <!-- 内容 -->
      <Title class="mt20">内容</Title>
      <div class="content-section">
        <div class="content-blocks">
          <div
            v-for="(item, idx) in contentList"
            :key="idx"
            class="content-block mb10"
            :class="item.isEdit === 1 ? 'editable-block' : 'non-editable-block'"
          >
            <div class="block-content">
              <div class="block-features">
                <div class="feature-item" v-html="item.content"></div>
              </div>
            </div>
            <div
              class="block-tag"
              :class="item.isEdit === 1 ? 'editable-tag' : 'non-editable-tag'"
            >
              {{ item.isEdit === 1 ? '可编辑' : '不可编辑' }}
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import templateMaterialsShareAnalyzeApi from "@/api/marketing/templateMaterialsShareAnalyze";
import Title from "@/components/Title";

export default {
  components: {
    Title
  },
  props: ["rowItem"],
  data() {
    return {
      info: {},
      contentList: []
    };
  },
  created() {
    this.handleShow();
  },
  methods: {
    // 格式化标题
    formatTitle(title) {
      if (!title) return "--";
      // 如果 title 是 JSON 字符串，尝试解析
      if (typeof title === "string") {
        try {
          const parsed = JSON.parse(title);
          if (Array.isArray(parsed)) {
            const names = parsed
              .map(it => it && (it.titleName || it.name || ""))
              .filter(Boolean);
            return names.length ? names.join(" / ") : title;
          }
        } catch (e) {
          // 如果不是 JSON，直接返回原值
        }
      }
      // 如果 title 已经是数组
      if (Array.isArray(title)) {
        const names = title
          .map(it => it && (it.titleName || it.name || ""))
          .filter(Boolean);
        return names.length ? names.join(" / ") : "--";
      }
      return title || "--";
    },
    // 格式化分享者信息
    formatSharer(name, identity, phone) {
      const parts = [];
      if (name) parts.push(name);
      if (identity) parts.push(`(${identity})`);
      if (phone) parts.push(phone);
      return parts.length ? parts.join("") : "--";
    },
    // 解析内容列表
    parseContentList(input) {
      try {
        const arr = typeof input === "string" ? JSON.parse(input) : input;
        if (Array.isArray(arr)) return arr;
      } catch (e) {
        console.error("解析内容失败:", e);
      }
      return [];
    },
    handleShow() {
      // 如果 rowItem 有 id，则通过 API 获取详情
      const id = (this.rowItem && this.rowItem.id) || (this.rowItem && this.rowItem.materialsId);
      if (id) {
        templateMaterialsShareAnalyzeApi
          .fetchById(id)
          .then(res => {
            const responseData = res.data || {};
            // API 返回的数据在 templateMaterialsShareAnalyzePO 中
            const po = responseData.templateMaterialsShareAnalyzePO || responseData || {};
            // 原文章信息可能在 templateMaterialsSharePO 中
            const originalPO = responseData.templateMaterialsSharePO || {};
            
            // 处理字段名映射（API 返回的是 coverimage，但我们需要 coverImage）
            const coverImage = po.coverimage || po.coverImage || originalPO.coverImage;
            const logoImg = po.logolmg || po.logoImg || originalPO.logoImg;
            
            // 构建 info 对象，合并所有数据
            this.info = {
              ...this.rowItem,
              ...po,
              // 统一字段名
              coverImage: coverImage,
              logoImg: logoImg,
              // 标题处理：优先使用 titleJson，如果没有则使用 title
              title: po.titleJson || po.title || this.rowItem.title,
              // 原文章标题（从原文章详情中获取）
              originalTitle: originalPO.titleJson || originalPO.title || po.title,
              // 确保 shareShowVO 被正确传递
              shareShowVO:
                this.rowItem.shareShowVO ||
                po.shareShowVO ||
                responseData.shareShowVO ||
                {}
            };
            
            // 解析内容
            this.contentList = this.parseContentList(po.content || this.rowItem.content);
          })
          .catch(err => {
            console.error("获取详情失败:", err);
            this.$message.error("获取详情失败");
            // 如果 API 失败，使用 rowItem 的数据
            this.info = { ...this.rowItem };
            this.contentList = this.parseContentList(this.rowItem.content || "");
          });
      } else {
        // 直接使用 rowItem 的数据
        this.info = { ...this.rowItem };
        this.contentList = this.parseContentList(this.rowItem.content || "");
      }
    },
    handleBack() {
      this.$emit("handleShow", "", 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.back-box {
  margin-bottom: 20px;
  div {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #409eff;
    img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
}

.basic-info {
  .info-item {
    display: flex;
    margin-bottom: 20px;
    .product-image {
      width: 120px;
      height: 80px;
      margin-right: 20px;
      flex-shrink: 0;
      .product-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }
    }
    .title-with-product {
      flex: 1;
      .title-text {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        color: #303133;
      }
      .p1 {
        font-size: 14px;
        color: #606266;
        margin: 5px 0;
      }
    }
  }
}

.content-section {
  .content-blocks {
    .content-block {
      position: relative;
      padding: 15px;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      margin-bottom: 10px;
      .block-content {
        .block-features {
          .feature-item {
            line-height: 1.6;
            color: #303133;
            ::v-deep img {
              max-width: 100%;
              height: auto;
            }
          }
        }
      }
      .block-tag {
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
      }
      .editable-tag {
        background: #f0f9ff;
        color: #409eff;
      }
      .non-editable-tag {
        background: #f5f7fa;
        color: #909399;
      }
    }
  }
}

.mt20 {
  margin-top: 20px;
}

.mb10 {
  margin-bottom: 10px;
}
</style>

